module.exports = __webpack_public_path__ + "img/journey.dad13b01.png";